<template>
  <div class="card-detalhes-nota-fiscal">
    <g-card :temCabecalho="false" :expansivel="false">
      <div class="header-detalhes-secundario">
        <div class="header-detalhes-secundario-titulo">
          <g-button
            class="buscar-button-header"
            largura="35px"
            icone="icone_voltar.svg"
            negritoTexto
            tamanhoIcone="10px"
            cor="#FFFFFF"
            altura="30px"
            :sombreado="false"
            @click="voltar()"
          />

          <div class="titulo-detalhes-cabecalho"> Detalhe da Nota Fiscal </div>
        </div>

        <div class="header-icons">
          <g-button
            class="botoes"
            altura="35px"
            largura="35px"
            tamanhoIcone="15px"
            icone="icone_print.svg"
            v-on:acao="abrirPDF"
            v-tooltip="'Abrir PDF'"
          >
          </g-button>

          <g-button
            altura="35px"
            largura="35px"
            tamanhoIcone="18px"
            class="button-compartilhar-copia"
            icone="pi pi-download"
            corIconeClass="4f2c19"
            @click="baixarPDF"
            v-tooltip="'Baixar PDF'"
          >
          </g-button>
        </div>
      </div>

      <div class="conteudo-card-detalhes-notas-fiscais espacamento-detalhes">
        <div class="titulo-grupo-detalhes">Detalhes
          <div class="header-icons">
            <g-button
            class="botoes"
            altura="35px"
            largura="35px"
            tamanhoIcone="15px"
            icone="pi pi-car"
            @click="itensNotasFiscais()"
            v-tooltip="'Itens da Nota Fiscal'"
            >
            </g-button>
          </div>
        </div>

        <div class="representante-cliente">
          <div class="representante-grid">
            <div class="titulo-conteudo-detalhes">Representante</div>
            <div class="label-conteudo">{{ detalhesNotasFiscaisViewModel.NomeRepresentante }}</div>
          </div>

          <div class="cliente-grid">
            <div class="titulo-conteudo-detalhes">Cliente/CNPJ</div>
            <div class="label-conteudo"> {{ detalhesNotasFiscaisViewModel.RazaoSocial }}</div>
          </div>
        </div>

        <div class="detalhes-container">
          <div class="nota-serie-grid">
            <div class="titulo-conteudo-detalhes">Nota / Série</div>
            <div class="label-conteudo"> {{ detalhesNotasFiscaisViewModel.CodigoExterno }}</div>
          </div>

          <div class="emissao-grid">
            <div class="titulo-conteudo-detalhes">Emissão</div>
            <div class="label-conteudo">{{ detalhesNotasFiscaisViewModel.DataEmissaoFormatada }}</div>
          </div>

          <div class="transportadora-grid">
            <div class="titulo-conteudo-detalhes">Transportadora</div>
            <div class="label-conteudo">{{ detalhesNotasFiscaisViewModel.NomeTransportadora }}</div>
          </div>

          <div class="frete-grid">
            <div class="titulo-conteudo-detalhes">Tipo Frete</div>
            <div class="label-conteudo">{{ detalhesNotasFiscaisViewModel.IndicadorDeTipoFreteTexto }}</div>
          </div>

          <div class="frete-porcentagem-grid">
            <div class="titulo-conteudo-detalhes">% Frete</div>
            <div class="label-conteudo">{{ detalhesNotasFiscaisViewModel.PercentualFrete }}%</div>
          </div>

          <div class="consignatario-grid">
            <div class="titulo-conteudo-detalhes">Consignatário</div>
            <div class="label-conteudo">{{ detalhesNotasFiscaisViewModel.CodigoConsignatorio || 'Sem Dados' }}</div>
          </div>

          <div class="zona-franca-grid">
            <div class="titulo-conteudo-detalhes">Zona Franca</div>
            <div class="label-conteudo">{{ detalhesNotasFiscaisViewModel.ZonaFranca === 'false' || 'Não' }} </div>
          </div>

          <div class="codigo-fiscal-grid">
            <div class="titulo-conteudo-detalhes">Código Fiscal</div>
            <div class="label-conteudo">{{ detalhesNotasFiscaisViewModel.CodigoFiscal }}</div>
          </div>

          <div class="origem-grid">
            <div class="titulo-conteudo-detalhes">Origem</div>
            <div class="label-conteudo">{{ detalhesNotasFiscaisViewModel.Origem }}</div>
          </div>

          <div class="situacao-grid">
            <div class="titulo-conteudo-detalhes">Situação</div>
            <div class="label-conteudo">{{ detalhesNotasFiscaisViewModel.SituacaoTexto }}</div>
          </div>

          <div class="finalidade-grid">
            <div class="titulo-conteudo-detalhes">Finalidade</div>
            <div class="label-conteudo">{{ detalhesNotasFiscaisViewModel.IndicadorFinalidadeTexto }}</div>
          </div>

          <div class="nat-operacao-grid">
            <div class="titulo-conteudo-detalhes">Nat. Operação</div>
            <div class="label-conteudo">{{ detalhesNotasFiscaisViewModel.DescricaoDaNaturezaDaOperacap }}</div>
          </div>

          <div class="peso-bruto-total-grid">
            <div class="titulo-conteudo-detalhes">Peso Bruto Total</div>
            <div class="label-conteudo">{{ detalhesNotasFiscaisViewModel.PesoTotalBrutoFormatado }}</div>
          </div>

          <div class="peso-liquido-total-grid">
            <div class="titulo-conteudo-detalhes">Peso Líquido Total</div>
            <div class="label-conteudo">{{ detalhesNotasFiscaisViewModel.PesoTotalLiquidoFormatado }}</div>
          </div>

          <div class="cond-pagamento-grid">
            <div class="titulo-conteudo-detalhes">Cond. Pagamento</div>
            <div class="label-conteudo">{{ detalhesNotasFiscaisViewModel.FormaDePagamento }}</div>
          </div>

          <div class="porcentagem-desconto-grid">
            <div class="titulo-conteudo-detalhes">% Desconto IPI</div>
            <div class="label-conteudo">{{ detalhesNotasFiscaisViewModel.PercentualDescontoIPI }}%</div>
          </div>

          <div class="ipi-grid">
            <div class="titulo-conteudo-detalhes">IPI</div>
            <div class="label-conteudo">{{ detalhesNotasFiscaisViewModel.ValorTotalIPIFormatado }}</div>
          </div>

          <div class="porcentagem-icm--grid">
            <div class="titulo-conteudo-detalhes">% ICM</div>
            <div class="label-conteudo">{{ detalhesNotasFiscaisViewModel.PercentualICMS }}%</div>
          </div>

          <div class="icm-grid">
            <div class="titulo-conteudo-detalhes">ICM</div>
            <div class="label-conteudo">{{ detalhesNotasFiscaisViewModel.ValorTotalICMFormatado }}</div>
          </div>

          <div class="porcentagem-desconto-grid">
            <div class="titulo-conteudo-detalhes">% Desconto</div>
            <div class="label-conteudo">{{ detalhesNotasFiscaisViewModel.ValorDescontoMercadoria }}%</div>
          </div>

          <div class="bonificacao-grid">
            <div class="titulo-conteudo-detalhes">Bonificação</div>
            <div class="label-conteudo">{{ detalhesNotasFiscaisViewModel.ValorTotalBonificacao }}</div>
          </div>

          <div class="total-bruto-grid">
            <div class="titulo-conteudo-detalhes">Total Bruto</div>
            <div class="label-conteudo">{{ detalhesNotasFiscaisViewModel.ValorTotalMercadoriaFormatado }}</div>
          </div>

          <div class="valor-total-nota-grid">
            <div class="titulo-conteudo-detalhes">Valor Total Nota</div>
            <div class="label-conteudo">{{ detalhesNotasFiscaisViewModel.ValorTotalNotaFiscalFaturaFormatado }}</div>
          </div>
        </div>

        <div class="titulo-grupo-detalhes">Outros</div>
        <div class="detalhes-container-outros">
          <div class="representante-adicional-grid">
            <div class="titulo-conteudo-detalhes">Representante Adicional</div>
            <div class="label-conteudo">{{ detalhesNotasFiscaisViewModel.RazaoSocial || 'Não Possui'}}</div>
          </div>

          <div class="dados-adicionais-fiscal-grid">
            <div class="titulo-conteudo-detalhes">Dados adicionais (fiscal)</div>
            <div class="label-conteudo">{{ detalhesNotasFiscaisViewModel.DadosAdicionalFiscal === 'null' || 'Não Possui'}}</div>
          </div>

          <div class="dados-adicionais-livre-grid">
            <div class="titulo-conteudo-detalhes">Dados adicionais (livre)</div>
            <div class="label-conteudo">{{ detalhesNotasFiscaisViewModel.DadosAdicionalLivre || 'Não Possui'}}</div>
          </div>
        </div>
      </div>
    </g-card>

    <g-pdf :fazDownload="podeBaixarPdf ? true : false" :downloadAoAbrir="true" :pdfFloat="false" :NovaGuia="abrePdf ? true : false" :executar="executarvisualizacao" :nomeArquivo="`NFE_${detalhesNotasFiscaisViewModel.SerieNotaFiscal}_${detalhesNotasFiscaisViewModel.CodigoExterno}`">
      <div class="render" v-if="renderiza">
        <PDFNotaFiscal 
          v-on:termino="gerarPdf" 
          :notaFiscal="NotaFiscalId" 
        /> 
      </div>
    </g-pdf>
  </div>
</template>

<script>
  import DetalhesNotasFiscais from './DetalhesNotasFiscais.js'
  export default DetalhesNotasFiscais
</script>

<style scoped>
.titulo-grupo-detalhes {
  display: flex;
  gap: 2%;
}
 
.header-titulo-voltar {
  width: 100%;
  display: flex;
  align-items: flex-end;
}

.agrupa-divs {
  display: flex;
  justify-content: space-between;
  grid-area: 1 / 1 / 2/ 7;
  flex-direction: column;
}

.titulo {
  text-align: left;
  font-family: "MontSerrat";
  font-weight: 700;
  margin-top: 15px;
  color: #4F2C19;
}

.conteudo {
  color: #8a8a8a;
  text-align: left;
  font-family: "MontSerrat";
  margin-bottom: 10px;
}

.card-titulo-detalhes-notas {
  color: #4f2c19;
  font-weight: bold;
  font-size: 1.1rem;
}

.grupo {
  color: #4f2c19;
  text-align: left;
  font-family: "MontSerrat";
  font-weight: bold;
  margin-top: 30px;
  display: flex;
  gap: 2%;
}

@media (min-width:310px) {
  .representante-cliente {
    display: flex;
    flex-direction: column;
    gap: 3%;
  }
  .header-detalhes-notas-fiscais {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 10px 0;
    border-bottom: 1px solid #f0f0f0;
  }
  .detalhes-container {
    display: grid;
    grid-template-columns: repeat(1, minmax(4em, 1fr));
    grid-template-rows: repeat(23, auto);
    column-gap: 3%;
  }
}

@media (min-width:368px) {
  .header-detalhes-notas-fiscais {
      grid-template-columns: 25% repeat(2, auto);
  }
  .detalhes-container {
    display: grid;
    grid-template-columns: repeat(2, minmax(4em, 1fr));
    grid-template-rows: repeat(12, auto);
    column-gap: 3%;
  }
}

@media (min-width:600px) {
  .header-detalhes-notas-fiscais {
    padding: 20px 0 10px;
  }
  .detalhes-container {
    display: grid;
    grid-template-columns: repeat(3, minmax(4em, 1fr));
    grid-template-rows: repeat(8, auto);
    column-gap: 3%;
  }
}

@media (min-width:801px) {
  .conteudo-card-detalhes-notas-fiscais {
    padding: 0 30px;
  }
  .detalhes-container {
    display: grid;
    grid-template-columns: repeat(4, minmax(4em, 1fr));
    grid-template-rows: repeat(6, auto);
    column-gap: 3%;
  }
}

@media (min-width:1025px) {
  .grupo {
    font-size: 19px;
  }

  .detalhes-container-outros {
    display: flex;
    flex-direction: column;
  }

  .conteudo-card-detalhes-notas-fiscais {
    padding: 0 50px;
  }

  .detalhes-container {
    display: grid;
    grid-template-columns: repeat(5, minmax(4em, 1fr));
    grid-template-rows: repeat(5, auto);
    column-gap: 3%;
  }
}

@media (min-width:1281px) {
  .detalhes-container {
    display: grid;
    grid-template-columns: repeat(6, minmax(4em, 1fr));
    grid-template-rows: repeat(4, auto);
    column-gap: 3%;
  }
}
</style>
